module.exports = "<div class=\"layout\">\n\n  <div>\n    <table [md2Data]=\"tableList\" #md2=\"md2DataTable\">\n      <thead>\n        <tr>\n          <th *ngFor=\"let x of column\">{{x}}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngFor=\"let i of md2.data\">\n          <td *ngFor=\"let m of column\" [innerHTML]=\"i[m]\"></td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n\n</div>\n<!-- <button (click)=\"callEmit()\">Click</button> -->\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src722008540/src/src/app/common/print/print/print.component.html
// module id = ../../../../../src/app/common/print/print/print.component.html
// module chunks = main